<template>
<div class="chapter">
<div class="inner_page">
<div id="dabef9d1bfb79-d1e403"><span id="page1">
<h2 class="chapter-number">ONE</h2>
<p class="flush-left-opener" style="text-indent:0;"><span class="drop-cap "><span class="drop-cap ">I</span> </span>can remember the brushwood jump rising, wickedly high, in front of us.</p>
<p class="indented">I can remember my uprush of exhilaration as Gold Sovereign soared sweetly up and over.</p>
<p class="indented">I can remember seeing, briefly, a horse lying on the grass on the far side of the jump, legs thrashing wildly as he sought to regain his feet.</p>
<p class="indented">I can remember Gold Sovereign twisting in mid-air as she tried, unsuccessfully, to avoid landing on top of him.</p>
<p class="indented">I can’t remember any more.</p>
<p class="indented">There must <em class="italic ">be </em>more because now here I am in this hard, high bed facing a blank wall. No long sweep of green turf bathed in golden sunshine stretching away out in front, just a cold, insipid, white wall.</p>
<p class="indented">‘And that’s all you remember?’ The white-coated doctor by the side of the bed peered at me over his rimless glasses and scribbled something indecipherable on to his clipboard.</p>
<p class="indented">I nodded. And regretted it. Any movement sent out screams of protest around my body. I breathed shallowly and waited for the pain to subside. Deep breaths were out. On its own, that told me I’d got cracked ribs at the very least. But looking down the length of bedcovers, there was a highly suspicious hump of unpleasantness which no doubt concealed a cage. It would be taking the weight off my left leg. A break, possibly, but a tentative wriggle of my toes produced no effect. What then?</p>
<p class="indented">I began to sweat.</p></span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781780106403_epub_chap001.vue?585bb01c